import React, { useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { Grid, Container, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../../components/shared/loading";
import FormDisplay from "./formDisplay";
import { getFormDetails } from "../../../../redux/docs";
import SubHeader from "./subHeader.jsx";
import { useParams } from "react-router-dom";
export const returnPageImage = (file, index) => {
  return `${file?.split("/docs-pdfs")?.[0]}/pg_${index + 1}/docs-pdfs${file?.split("/docs-pdfs")?.[1]?.replace("pdf", "png")}`;
};

const EditForm = (props) => {
  let { classes } = props;
  // const { formId, fromDataOld } = state;
  const [formData, setFormData] = useState();
  const { id, form_id } = useParams();
  const dispatch = useDispatch();
  const formDetail = useSelector((item) => item.DocsLibrary.formDetail);
  const adminAuth = useSelector((state) => state.adminAuth);

  useEffect(() => {
    if (form_id) {
      dispatch(getFormDetails({ id: form_id }));
    }
  }, [form_id]);

  useEffect(() => {
    if (formDetail) {
      setFormData(formDetail.data);
    }
  }, [formDetail]);

  return (
    <div className={classes.pageRoot}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} sx={{ pt: "0 !important" }}>
          <Box sx={{ height: "auto", width: "100%" }}>
            {formDetail.isLoading ? (
              <div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <Box
                  sx={{
                    p: 8,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loading />
                </Box>
              </div>
            ) : (
              formData && (
                <Container maxWidth="xl" sx={{ padding: "0 !important" }}>
                  <SubHeader formDetail={formDetail} id={id} {...props} />
                  <Grid container spacing={2}>
                    <Grid item xs={12} spacing={4}>
                      <FormDisplay {...props} formDetail={formDetail} setFormData={setFormData} adminDetails ={adminAuth?.adminDetail}/>
                    </Grid>
                  </Grid>
                </Container>
              )
            )}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

// export default EditForm;
export default withStyles(styleSheet, { name: "EditDocumentStyle" })(EditForm);
